<template>
  <div class="c-sitter__feedback">
    <div class="divider"></div>
    <fieldset id="public_feedback" class="c-feedback__form" name="public_feedback">
      <span class="c-optional__label">Optional</span>
      <p class="c-feedback__title">Help {{ sitterFirstName }} out with a public review</p>

      <p v-show="hasGoodScore" class="c-feedback__subheader">
        Reviews are a very important factor in a family’s decision to work with a sitter.
      </p>
      <PoppinsTextArea
        id="public_feedback_text"
        v-model="publicFeedback"
        name="public_feedback_text"
        class="mb-32 review-feedback-box"
        labelName="Your review..."
        :rows="6"
        @keyupOnce="ratingSegmentEvent('Review Started')"
        @input="onInput"
      />
      <PoppinsButton
        id="createReview"
        type="submit"
        size="medium"
        class="mr-8 w-full sm:!w-auto"
        :value="`Rate ${sitterFirstName}`"
        @click.prevent="createReview"
      />
      <PoppinsButton
        class="w-full sm:!w-auto mt-16 sm:!mt-0"
        value="Cancel Review"
        :href="returnPath"
        variant="text"
        @click="ratingSegmentEvent('Rating Abandoned')"
      />
    </fieldset>
  </div>
</template>

<script lang="ts">
import TextArea from '@/components/textarea/TextArea.vue';
import Button from '@/components/button/Button.vue';

export default {
  name: 'PublicFeedback',
  components: {
    PoppinsTextArea: TextArea,
    PoppinsButton: Button,
  },
  props: {
    returnPath: {
      type: String,
      required: true,
    },
    sitterFirstName: {
      type: String,
      required: true,
    },
    ratingSegmentEvent: {
      type: Function,
      required: false,
      default: () => {},
    },
    createReview: {
      type: Function,
      required: true,
    },
    score: {
      type: Number,
      required: true,
    },
  },
  data(): any {
    return {
      publicFeedback: '',
    };
  },
  computed: {
    hasGoodScore(): boolean {
      return this.score > 3;
    },
  },
  methods: {
    onInput() {
      this.$emit('input', this.publicFeedback);
    },
  },
};
</script>
